import { Router } from '@angular/router';
import { Component, OnInit, EventEmitter, HostListener, ChangeDetectionStrategy, Input, ChangeDetectorRef, Output } from '@angular/core';
import { catchError } from 'rxjs/operators';
import { of } from 'rxjs';


import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';

import { TrackingSegmentService } from '@unico-people/shared/data-access-tracking-segment';
import { EmployeesService } from '../../services/employees/employees.service';

import { UiModalDefaultComponent } from '@unico-people/shared/dashboard/ui-modal-default';

import { SegmentEventName } from '@unico-people/shared/enums/utils-enums';
import { SessionStorage } from '@unico-people/shared/utils/storage';

@Component({
  selector: 'app-profile-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HeaderComponent implements OnInit {
  @Input() position: any;
  @Input() isColaboratorModule: boolean;
  @Output() updateCollab: EventEmitter<boolean> = new EventEmitter<boolean>();

  unit: string;
  info: any;
  uuid: string;
  colabId: string;
  personName: string;
  phone: string;
  email: string;
  status: any;
  modules: any;
  isStatus: boolean;
  isStatusCollab: boolean;
  errorUpdateCollaborator: any;
  dialogCollaborator: MatDialogRef<UiModalDefaultComponent>;

  user: any;
  action = false;
  url: string;
  sendModelsKit: boolean;
  message: string;
  active: boolean;

  constructor(
    public dialog: MatDialog,
    public _snackBar: MatSnackBar,
    public cd: ChangeDetectorRef,
    private employeesService: EmployeesService,
    private segment: TrackingSegmentService,
    private router: Router
  ) {}

  @HostListener('document:click', ['$event'])
  clickedOutside(): void {
    this.action = false;
  }

  ngOnInit(): void {
    const colaborator = this.position;
    this.personName = colaborator?.name;
    this.active = this.position?.active || false;
  }

  openStatus(): void {
    this.isStatus = !this.isStatus;
  }

  openStatusCollab(): void {
    this.isStatusCollab = !this.isStatusCollab;
  }

  closeStatus(): void {
    this.isStatus = false;
  }

  clickInside(e): void {
    e.stopPropagation();
  }

  openDialogChangeStatus(event): void {
    if (event.target.checked) {
      this.dialogCollaborator = this.dialog.open(UiModalDefaultComponent, {
        disableClose: false
      });
      const dialogInstance = this.dialogCollaborator?.componentInstance;
      dialogInstance.confirmMessage = 'Deseja ativar o(a) colaborador(a)?';
      dialogInstance.menssageSubtitle = 'Os serviços do(a) colaborador(a) serão desligados.';
      dialogInstance.confirmMessageButton = 'Ativar';
      this.dialogCollaborator.afterClosed().subscribe(confirmed => {
        if (confirmed) {
          this.active = true;
          this.employeesService.changeEmployeeStatus(this.position.id, this.active).subscribe(() => {
            this.updateCollab.emit(true);
            this.cd.detectChanges();
            catchError(err => of( this.errorUpdateCollaborator = err?.error?.code))
          });
          this.segment.track(SegmentEventName.profile_active, { account: SessionStorage.getItem('currentAccountName') });
          if (this.active === true) {
            this._snackBar.open('Colaborador ativado com sucesso!', '', {
              duration: 3000
            });
          }
          if (this.errorUpdateCollaborator) {
            this._snackBar.open('Houve erro ao ativar o colaborador, tente novamente.', '', {
              duration: 3000
            });
          }
        }
      });
    } else {
      this.dialogCollaborator = this.dialog.open(UiModalDefaultComponent, {
        disableClose: false
      });
      const dialogInstance = this.dialogCollaborator?.componentInstance;
      dialogInstance.confirmMessage = 'Deseja desativar o(a) colaborador(a)?';
      dialogInstance.menssageSubtitle = 'Os serviços do(a) colaborador(a) serão desligados.';
      dialogInstance.confirmMessageButton = 'desativar';
      this.dialogCollaborator.afterClosed().subscribe(confirmed => {
        if (confirmed) {
          this.active = false;
          this.employeesService.changeEmployeeStatus(this.position.id, this.active).subscribe(() => {
            this.updateCollab.emit(false);
            this.cd.detectChanges();
            catchError(err => of( this.errorUpdateCollaborator = err?.error?.code))
          });
          if (this.active === false) {
            this._snackBar.open('Colaborador desativado com sucesso!', '', {
              duration: 3000
            });
          }
          if (this.errorUpdateCollaborator) {
            this._snackBar.open('Houve erro ao desativar o colaborador, tente novamente.', '', {
              duration: 3000
            });
          }
        }
      });
    }
  }
}
